export class IStorageStrategy {
}
